import { render, staticRenderFns } from "./DashboardSidebarItem.vue?vue&type=template&id=56c39250&lang=pug"
import script from "./DashboardSidebarItem.vue?vue&type=script&lang=js"
export * from "./DashboardSidebarItem.vue?vue&type=script&lang=js"
import style0 from "./DashboardSidebarItem.vue?vue&type=style&index=0&id=56c39250&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports